export default {
  helloWorld: "Merhaba, Dünya!",
  warning: "Uyarı",
  Close: "Kapat",
  NameSurname: "Ad Soyad",
  Dial: "Çağrı Oluştur",
  Default: "Varsayılan",
  Error: "Hata",
  ErrorText: "Bir hata oluştu!",
  OK: "Tamam",

  DeviceSettings: "Cihaz Ayarları",
  SelectMic: "Mikrofon aygıtını seçin",
  SelectCam: "Kamera aygıtını seçin",
  RefreshDeviceList: "Listeyi Yenile",
  ClearDeviceSelections: "Seçimleri Temizle",
  Save: "Kaydet",

  DemoInQueue: "Çağrınız sıraya alındı. Müşteri temsilcimiz ile görüşmek için lütfen bekleyin.",
  DemoTitle: "Demo Çağrısı Oluştur",

  CheckingLicense: "Lisans Kontrol Ediliyor..",
  LoadingData: "Veriler Yükleniyor..",

  AGENT_CHECK_FAIL: "Agent kontrolü başarısız!",
  AGENT_CREATE_FAIL: "Agent oluşturma başarısız!",
  AGENT_NOT_FOUND: "Agent bulunamadı!",
  UNKNOWN_LICENSE_TYPE: "Bilinmeyen lisans tipi!",
  LICENSE_NOT_FOUND: "Lisans bulunamadı!",
  LICENSE_COUNT_INVALID: "Lisans sayısı 1'den az olamaz!",
  LICENSE_EXPIRED: "Lisans süresi dolmuş!",
  LICENSE_HOST_INVALID: "Lisans adresi geçersiz!",
  LICENSE_ERROR_MESSAGE: "Lisans kontrolü sırasında bir hata oluştu, lütfen teknik destek ile iletişime geçin.",

  ASSIGNED_LICENSE_CHECK_ERROR: "Atanmış lisans kontrol hatası!",
  ASSINGED_LICENSE_NOT_FOUND: "Atanmış lisans bulunamadı!",
  ASSIGNED_LICENSE_CHECK_TOTAL_ERROR: "Atanmış lisans toplam kontrol hatası!",
  LICENSE_COUNT_EXCEEDED: "Lisans sayısı aşıldı!",
  ASSIGNED_LICENSE_INSERT_ERROR: "Atanmış lisans ekleme hatası!",

  CONCURRENT_LICENSE_CANNOT_LOCK: "Concurrent lisans kilit hatası!",
  CONCURRENT_LICENSE_FULL: "Concurrent lisans tüm slotlar dolu!",

  INFO: "Bilgi",

  NoCameraPermission: "Kamera izni yok!",
  NoMicrophonePermission: "Mikrofon izni yok!",

  MaxFileSizeExceeded: "Dosya boyutu {size} MB'dan büyük olamaz!",
  InvalidFileType: "Geçersiz dosya tipi! Kabul edilen dosya tipleri: {types}",

  callEnded: "Görüşme Sona Erdi",
  callEndedMessage: "Görüntülü görüşme sona erdi.",

  pageNotFound: "Sayfa Bulunamadı",
  pageNotFoundMessage: "Aradığınız sayfa mevcut değil.",
};
